import { useRouteMatch, Switch, Route } from "react-router";
import Religion from "./Religion";

const ReligionRoot = (props) => {
  let { path } = useRouteMatch();

  return (
    <>
      <Switch>
        <Route path={`${path}`} component={Religion} />
      </Switch>
    </>
  );
};

export default ReligionRoot;
